<template>
  <div v-if="showDialog"
       class="festival-container">
    <div class="festival-box">
      <div class="wrapper">
        <img class="wrapper-img"
             src="https://new-bullet-static.oss-cn-shanghai.aliyuncs.com/miniprogram/bullet/acc-fee-notice-short.png"
             alt="">
      </div>
      <div :class="{ 'button': true, 'pointer': true, 'disbtn': flag }"
           @click="handleClose">{{ isCountingDown ? `${countdown}秒`: '我已知晓' }}
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import user from '@/utils/user'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDialog: false,
      isCountingDown: true,
      countdown: 5,
      countdownTimer: null
    }
  },
  created() {
    this.checkAndShowNotice()
  },
  beforeUnmount() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },
  methods: {
    checkAndShowNotice() {
      // 检查是否超过截止时间
      const deadline = dayjs('2026-03-13 00:00:00')
      const now = dayjs()

      if (now.isAfter(deadline)) {
        return
      }

      // 获取今天的日期
      const today = dayjs().format('YYYY-MM-DD')
      const companyId = user.companyId || ''
      const userId = user.userId || ''
      const storageKey = `ax_rate_pop_${companyId}_${userId}`
      const lastClosedDate = localStorage.getItem(storageKey)

      // 如果今天已经关闭过，则不显示
      if (lastClosedDate === today) {
        return
      }

      // 显示弹框
      this.showDialog = true
      this.startCountdown()
    },
    startCountdown() {
      this.isCountingDown = true
      this.countdown = 5

      this.countdownTimer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer)
          this.isCountingDown = false
        }
      }, 1000)
    },
    handleClose() {
      if (this.isCountingDown) {
        return
      }
      const companyId = user.companyId || ''
      const userId = user.userId || ''
      const storageKey = `ax_rate_pop_${companyId}_${userId}`
      // 记录今天已关闭
      const today = dayjs().format('YYYY-MM-DD')
      localStorage.setItem(storageKey, today)

      // 关闭弹框
      this.showDialog = false

      // 清理计时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
      }
    },
    handleBackdropClick(e) {
      // 只有点击背景才关闭，不能通过点击弹框内容关闭
      if (e.target === e.currentTarget) {
        return
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.itembox
  line-height 17px
  color #565868
  font-size 12px
  border-radius 8px
  opacity 1
  background #F7F8FA
  padding 8px 10px
  box-sizing border-box
.deepblue-line
  background linear-gradient(90deg, #1C2A55 46%, #295886 100%)
  -webkit-background-clip text
  -webkit-text-fill-color transparent
.flex-center
  align-items center
  display flex
  justify-content center
.deepblue
  color #1C2B55
.blue
  color #2EA1FF
.festival-container
  position fixed
  left 0
  top 0
  width 100%
  height 100%
  background rgba(0, 0, 0, 0.7)
  z-index 100
.festival-box
  width 600px
  height 560px
  background-size 100% 100%
  position absolute
  left 50%
  top 45%
  transform translate(-50%, -50%)
.disbtn
  background #7FCAFF !important
.button
  width 170px
  height 35px
  line-height 35px
  background #0096FF
  border-radius 16px
  color #fff
  text-align center
  margin 12px auto 14px
.close
  position absolute
  right 20px
  top 40px
  font-size 32px
.fs-34
  font-size 34px
.header-box
  width 100%
  color #fff
.pd-b-15
  padding-bottom 15px
.pd-t-26
  padding-top 26px
.wrapper
  width 100%
  height 100%
  overflow auto
  box-sizing border-box
  scrollbar-width none
  -ms-overflow-style none
  .wrapper-img
    width 100%
    height 100%
.content-box
  border-radius 12px
  color #1F2021
.icon-dot
  display block
  width 12px
  flex-shrink 0
  height 12px
  background url('../../assets/dialog/case-notice/icon-dot-2.png') no-repeat
.mg-l-15
  margin-left 17px
.fc-lightgray
  color #686868
.fc-blue
  color #061EB6
</style>
